module.exports = __webpack_public_path__ + "img/select-icon1.6a6709b0.png";